import React, { useState } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import SectionContainer from '../SectionContainer';
import Field, { hasDataInFields } from '../../Field';
import { IconArrow, IconReview, IconTrustpilot } from '../../../../components';
import Slider from 'react-slick';

import css from './SectionCustomerReviews.module.css';
import client1Image from './images/1.png';
import client2Image from './images/2.png';
import client3Image from './images/3.png';

const NextArrow = ({ onClick }) => (
  <div className={classNames(css.arrow, css.arrowRight)} onClick={onClick}>
    <IconArrow direction="right" />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className={classNames(css.arrow, css.arrowLeft)} onClick={onClick}>
    <IconArrow direction="left" />
  </div>
);

const SectionCustomerReviews = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    numColumns,
    title,
    description,
    appearance,
    callToAction,
    blocks,
    isInsideContainer,
    options,
    intl,
  } = props;

  const [currentSlide, setCurrentSlide] = useState(0);

  const SLIDER_SETTINGS = {
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: index => setCurrentSlide(index),
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  const reviews = [
    {
      title1: intl.formatMessage({ id: 'LandingPage.SectionCustomerReviews.review1.title' }),
      review1: intl.formatMessage({ id: 'LandingPage.SectionCustomerReviews.review1.review' }),
      title2: intl.formatMessage({ id: 'LandingPage.SectionCustomerReviews.review2.title' }),
      review2: intl.formatMessage({ id: 'LandingPage.SectionCustomerReviews.review2.review' }),
      title3: intl.formatMessage({ id: 'LandingPage.SectionCustomerReviews.review3.title' }),
      review3: intl.formatMessage({ id: 'LandingPage.SectionCustomerReviews.review3.review' }),
      ratingTitle: 'Ausgezeichnet',
      rating: 5,
      count: 266,
      client: {
        image: client1Image,
        name: intl.formatMessage({ id: 'LandingPage.SectionReviews.review1.clientName' }),
        bio: intl.formatMessage({ id: 'LandingPage.SectionReviews.review1.clientBio' }),
      },
    },
    {
      title1: intl.formatMessage({ id: 'LandingPage.SectionCustomerReviews.review1.title' }),
      review1: intl.formatMessage({ id: 'LandingPage.SectionCustomerReviews.review1.review' }),
      title2: intl.formatMessage({ id: 'LandingPage.SectionCustomerReviews.review2.title' }),
      review2: intl.formatMessage({ id: 'LandingPage.SectionCustomerReviews.review2.review' }),
      title3: intl.formatMessage({ id: 'LandingPage.SectionCustomerReviews.review3.title' }),
      review3: intl.formatMessage({ id: 'LandingPage.SectionCustomerReviews.review3.review' }),
      ratingTitle: 'Ausgezeichnet',
      rating: 5,
      count: 266,
      client: {
        image: client2Image,
        name: intl.formatMessage({ id: 'LandingPage.SectionReviews.review2.clientName' }),
        bio: intl.formatMessage({ id: 'LandingPage.SectionReviews.review2.clientBio' }),
      },
    },
    {
      title1: intl.formatMessage({ id: 'LandingPage.SectionCustomerReviews.review1.title' }),
      review1: intl.formatMessage({ id: 'LandingPage.SectionCustomerReviews.review1.review' }),
      title2: intl.formatMessage({ id: 'LandingPage.SectionCustomerReviews.review2.title' }),
      review2: intl.formatMessage({ id: 'LandingPage.SectionCustomerReviews.review2.review' }),
      title3: intl.formatMessage({ id: 'LandingPage.SectionCustomerReviews.review3.title' }),
      review3: intl.formatMessage({ id: 'LandingPage.SectionCustomerReviews.review3.review' }),
      ratingTitle: 'Ausgezeichnet',
      rating: 5,
      count: 266,
      client: {
        image: client3Image,
        name: intl.formatMessage({ id: 'LandingPage.SectionReviews.review3.clientName' }),
        bio: intl.formatMessage({ id: 'LandingPage.SectionReviews.review3.clientBio' }),
      },
    },
  ];

  const hasReviews = !!reviews && reviews?.length > 0;
  const currentReview = reviews[currentSlide];

  return (
    <SectionContainer
      id={sectionId}
      className={classNames(className, css.whyUs)}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      <div className={css.container}>
        {/* {hasReviews ? (
          <div className={css.left}>
            <Slider {...SLIDER_SETTINGS} className={css.slider}>
              {reviews.map(review => (
                <div className={css.reviewContainer}>
                  <div className={css.client}>
                    <img
                      className={css.clientImage}
                      alt={review.client.name}
                      src={review.client.image}
                    />
                    <div className={css.clientDetails}>
                      <div className={css.name}>{review.client.name}</div>
                      <div className={css.description}>{review.client.bio}</div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        ) : null} */}
        <div className={css.right}>
          {hasHeaderFields ? (
            <header className={classNames(css.header, defaultClasses.sectionDetails)}>
              <Field data={title} className={defaultClasses.title} options={fieldOptions} />
              <Field
                data={description}
                className={defaultClasses.description}
                options={fieldOptions}
              />
              <Field
                data={callToAction}
                className={defaultClasses.ctaButton}
                options={fieldOptions}
              />
            </header>
          ) : null}

          <div className={css.reviewWrapper}>
            <div className={css.reviewBlock}>
              <div className={css.reviewBlockNumber}>{'01'}</div>
              <div>
                <div className={css.reviewTitle}>{currentReview.title1}</div>
                <div className={css.review}>{currentReview.review1}</div>
              </div>
            </div>
            <div className={css.reviewBlock}>
              <div className={css.reviewBlockNumber}>{'02'}</div>
              <div>
                <div className={css.reviewTitle}>{currentReview.title2}</div>
                <div className={css.review}>{currentReview.review2}</div>
              </div>
            </div>
            <div className={css.reviewBlock}>
              <div className={css.reviewBlockNumber}>{'03'}</div>
              <div>
                <div className={css.reviewTitle}>{currentReview.title3}</div>
                <div className={css.review}>{currentReview.review3}</div>
              </div>
            </div>
            <div className={css.rating}>
              <div className={css.ratingTitle}>
                {currentReview.ratingTitle}
                <span title={`${currentReview.rating}/5`}>
                  {[1, 2, 3, 4, 5].map(star => (
                    <IconReview
                      key={`star-${star}`}
                      className={css.reviewRatingStar}
                      isFilled={star <= currentReview.rating}
                    />
                  ))}
                </span>
              </div>

              <div className={css.ratingCount}>
                {intl.formatMessage(
                  { id: 'LandingPage.SectionReviews.count' },
                  { count: <span>{currentReview.count}</span> }
                )}
              </div>
              <div className={css.trustpilot}>
                <IconTrustpilot />
                <span>{intl.formatMessage({ id: 'LandingPage.SectionReviews.trustpilot' })}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SectionContainer>
  );
};

SectionCustomerReviews.defaultProps = {
  className: null,
  rootClassName: null,
};

SectionCustomerReviews.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
};

export default SectionCustomerReviews;
